var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('div',{staticClass:"bookmark animation",class:{
    'animation--flip-in-x': _vm.disabled
  },on:{"click":function($event){$event.preventDefault();return _vm.toggleBookmark.apply(null, arguments)}}},[_c('a',{staticClass:"bookmark__link",attrs:{"href":"#"}},[(_vm.showCopy)?_c('span',[_vm._v("Bookmark")]):_vm._e(),_vm._v(" "),(_vm.active)?_c('BookmarkFull',{class:`w-${_vm.iconSize} h-${_vm.iconSize}`}):_c('BookmarkEmpty',{class:`w-${_vm.iconSize} h-${_vm.iconSize}`})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }